import PropTypes from 'prop-types';
import React from 'react';
import { FormattedNumber } from 'react-intl';

const Money = ({ amount, currency }) => (
  <FormattedNumber
    // Check if payment value is truthy (not zero) to avoid negative zero
    value={amount || 0}
    // eslint-disable-next-line react/style-prop-object
    style="currency"
    currency={currency}
  />
);

Money.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  currency: PropTypes.string,
};

Money.defaultProps = {
  currency: 'JPY',
};

export default Money;
